import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat } from '@/utils'

export interface Job {
  id: number
  group: SystemCode
  name: string
  status: SystemCode
  formatType: string
  startTime: string
  endTime: string
  progress: string
  processedTime: string
  processedBranchCode: SystemCode
  processedPlaceCode: SystemCode
  processedIpAddress: string
  processedSystemUserId: string
  processedSystemUserName: string
  message: string
  note: string
  csvUrl: string
  templateUrl: string
  canCsvDownload: boolean
  downloads: Download
}

export interface Download {
  id: number
  jobRequestId: number
  title: string
  fileName: string
  url: string
}

export function JobFromJSON(json: any): Job {
  return {
    id: exists(json, 'id') ? json.id : 0,
    group: exists(json, 'group')
      ? SystemCodeFromJSON(json.group)
      : defaultSystemCode(),
    name: exists(json, 'name') ? json.name : '',
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    formatType: exists(json, 'format_type') ? json.format_type : '',
    startTime: exists(json, 'start_time')
      ? dateTimeToPlainFormat(json.start_time)
      : '',
    endTime: exists(json, 'end_time')
      ? dateTimeToPlainFormat(json.end_time)
      : '',
    progress: exists(json, 'progress') ? json.progress : '',
    processedTime: exists(json, 'processed_time')
      ? dateTimeToPlainFormat(json.processed_time)
      : '',
    processedBranchCode: exists(json, 'processed_branch_code')
      ? SystemCodeFromJSON(json.processed_branch_code)
      : defaultSystemCode(),
    processedPlaceCode: exists(json, 'processed_place_code')
      ? SystemCodeFromJSON(json.processed_place_code)
      : defaultSystemCode(),
    processedIpAddress: exists(json, 'processed_ip_address')
      ? json.processed_ip_address
      : '',
    processedSystemUserId: exists(json, 'processed_system_user_id')
      ? json.processed_system_user_id
      : '',
    processedSystemUserName: exists(json, 'processed_system_user_name')
      ? json.processed_system_user_name
      : '',
    message: exists(json, 'message') ? json.message : '',
    note: exists(json, 'note') ? json.note : '',
    csvUrl: exists(json, 'download_url') ? json.download_url : '',
    templateUrl: exists(json, 'template_url') ? json.template_url : '',
    canCsvDownload: exists(json, 'can_csv_download')
      ? json.can_csv_download
      : '',
    downloads: json.downloads.map(DownloadsFromJSON)
  }

  function DownloadsFromJSON(json: any): Download {
    return {
      id: exists(json, 'id') ? json.id : '',
      jobRequestId: exists(json, 'job_request_id') ? json.job_request_id : '',
      title: exists(json, 'title') ? json.title : '',
      fileName: exists(json, 'file_name') ? json.file_name : '',
      url: exists(json, 'url') ? json.url : ''
    }
  }
}
